// Name of the application
export const APP_NAME = 'BioVerse';
